import QuestionViewVerbal from "./QuestionViewVerbal";

export default class QuestionViewVerbalSum extends QuestionViewVerbal {
    constructor(question) {
        super(question);

        if (this._question.selectMultiNum > 1) {
            this._inputField.visible = false;
        }
    }

    isCorrect() {
        if (Array.isArray(this._inputValue)) {
            const answerDoubled = this._question.answer.value * 2;
            let sum = 0;
            for (let i = 0; i < this._inputValue.length; i++) {
                sum += this._inputValue[i].value;
            }
            return sum === answerDoubled;
        } else {
            console.log(this._inputValue.value);
            console.log(this._question.answer.value);
            return this._inputValue.value === this._question.answer.value;
        }

        /*
        let answer = this._question.values[this._question.values.length-1].value;
        console.log('correct answer:' + answer);
        let result;
        
        if (this._question.select_multi_num){
            //if an array
            result = this._inputValue.length === this._question.select_multi_num;
            if(result){
                for(let i = 0; i < this._inputValue.length; i++){
                    if(!this.checkAnswer(this._inputValue[i].value, answer)){
                        result = false;
                    }
                }
            }
        } else {
            result = this.checkAnswer(this._inputValue.value, answer);
        }

        return result;

        */
    }

    /*
    checkAnswer(option, answer) {
        let numArr = option.split(/[\x/+-]+/);
        let opArr = option.split(/[0-9]/);
        for(let i = opArr.length-1; i >= 0; i--){
            if(opArr[i] === '') opArr.splice(i, 1);
        }
        let val = Number(numArr[0]);
        for(let i = 0; i < opArr.length; i++)
        {
            if(opArr[i] === '+')
                val = val + Number(numArr[i+1]);
            else if(opArr[i] === '-')
                val = val - Number(numArr[i+1]);
            else if(opArr[i] === 'x')
                val = val * Number(numArr[i+1]);
            else if(opArr[i] === '/')
                val = val / Number(numArr[i+1]);
        }
        //console.log(val + ', ' + answer);
        let result = val === answer;
        if(this._question.sum_type === 'not_equal_to'){ 
            result = !result;
        }
        return result;
    }
    */

    filterTemplate(x) {
        return true;
    }
}